// extracted by mini-css-extract-plugin
export default {"form_body_top":"self-consumed_form_body_top__iX-g0","form_body_top_group_top":"self-consumed_form_body_top_group_top__cpqxB","table-container":"self-consumed_table-container__lh0x2"};